import Button from "../components/Button";
import useLogOut from "../hooks/useLogout";
import { useNavigate } from "react-router-dom";
import { captureException } from "@sentry/react";

const CommonConclusion = () => {
  return (
    <div className="flex min-h-screen flex-col bg-secondary p-4 pt-8">
      <div className="mx-auto flex min-h-[90dvh] max-w-md grow flex-col text-center">
        <div className="grow font-medium ">
          <h1 className="whitespace-pre-wrap text-3xl font-semibold">
            {"Yuhuuuuu!\nEsperienza caricata ✌️"}
          </h1>

          <h2 className="mb-8 mt-6 whitespace-pre-wrap">
            {"SCARICA L’APP!\n\nTroverai i punti accumulati sul tuo profilo!"}
          </h2>

          <span className="text-8xl">🥳</span>
        </div>

        <Button onPress={() => window.open("https://onelink.to/behnx6")}>
          Scarica l'app
        </Button>
      </div>
    </div>
  );
};

export default function LogOut() {
  const navigate = useNavigate();
  useLogOut()
    .then(() => navigate("/"))
    .catch((error) => {
      console.error("Failed to logout", error);
      captureException(error);
    });

  return <CommonConclusion />;
}
